<template>
  <div @click="day_show = false">
    <div class="main">
      <!-- 下推广告 -->
      <a href="javascript:;">
        <div class="topGuangGao" v-if="isXiaTuiGG">
          <!-- <h1>下推广告</h1> -->
          <span>广告</span>
          <img :src="push_down_adv.image" alt="" @click="topCloseGG2(push_down_adv.param, push_down_adv.url)" />
          <button class="topGuangGao_btn" @click="topCloseGG()">
            关闭广告
          </button>
        </div>
      </a>

      <!-- 下推广告回收位 -->
      <a href="javascript:;">
        <div class="rightBottomGG" v-if="isXiaTuiGG2">
          <!-- 广告位置 -->
          <!-- <img :src="push_down_adv.image" alt="" @click="topCloseGG2(push_down_adv.param,push_down_adv.url)"> -->
          <img :src="push_down_adv.image" alt="" @click="topCloseGG4()" />
          <span>广告</span>
          <button class="topGuangGao_btn2" @click.stop="topCloseGG3()" style="top:-25px">
            关闭广告
          </button>
        </div>
      </a>

      <!-- 浮层广告 -->
      <a href="javascript:;">
        <div class="fucengGG" v-if="isFuCengGG">
          <!-- <h1>浮层广告</h1> -->
          <span>广告</span>
          <img :src="floating_layer_adv.image" alt=""
            @click="fucengGG2(floating_layer_adv.param, floating_layer_adv.url)" />
          <button class="fucengGGHS_btn" style="top:-25px" @click="fucengGG()">
            关闭广告
          </button>
        </div>
      </a>

      <!-- 浮层广告回收位 -->
      <a href="javascript:;">
        <div class="fucengGGHS" v-if="isFuCengGG2">
          <!-- 广告位置 -->
          <!-- <img :src="floating_layer_adv.image" alt="" @click="fucengGG2(floating_layer_adv.param,floating_layer_adv.url)"> -->
          <img :src="floating_layer_adv.image" alt="" @click="fucengGG4()" />
          <span>广告</span>
          <button class="fucengGGHS_btn2" style="top:-25px" @click.stop="fucengGG3()">
            关闭广告
          </button>
        </div>
      </a>

      <!-- 顶部广告条 -->
      <div class="topBanner" v-if="top_adv.image" @click="topAdvClick(top_adv.param, top_adv.url)">
        <img :src="top_adv.image" alt />
        <span>广告</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="rotation">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, i) in bannerList" :key="i">
                  <img :src="item.cover_url" :alt="item.cover_des" />
                  <!-- <div class="laber">
                    <p>{{ item.subtitle }}</p>
                    <p>{{ item.title }}</p>
                  </div> -->
                  <!-- <div class="others">
                    <img src="@/assets/img/shadow.png" alt />
                  </div> -->
                </div>
              </div>
              <!-- 分页器 -->
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div class="content-list">
            <template v-for="(item, index) in list">
              <div class="bigBox" :key="index">
                <div class="list-box">
                  <div class="img" @click="detail(item)">
                    <img :src="item.cover_url" alt v-if="typeof item.cover_url == 'string'" />
                    <img :src="item.cover_url[0]" alt v-else />
                    <!-- 音频 -->
                    <img src="@/assets/img/icon_voice.png" alt class="voiceImg"
                      v-if="item.par_type == 'sound_article'" />
                    <!-- 杂志 -->
                    <img src="@/assets/img/icon_lock.png" alt class="voiceImg" v-if="
                      item.par_type == 'magazine_article' &&
                      item.is_jurisdiction == false
                    " />
                  </div>
                  <div class="suggest">
                    <!-- 单行本标题 -->
                    <p @click="detail(item)" v-if="item.par_type == 'theme'">
                      {{ item.name }}
                    </p>
                    <!-- 杂志 -->
                    <p v-else-if="item.par_type == 'magazine_article'" class="articleType">
                      <span>{{ item.title }}</span>
                      <el-button @click="goMember" v-if="item.is_jurisdiction == false">订阅</el-button>
                    </p>
                    <!-- 其他标题 -->
                    <p @click="detail(item)" v-else>{{ item.title }}</p>
                    <div class="message">
                      <!-- 免费单行本 -->
                      <!-- {{item.type}} -->
                      <div v-if="item.par_type == 'theme_article'" v-for="(i, k) in item.themes" style="color:#0091ff"
                        @click="freeTheme(item, i.id)" :key="k">
                        #{{ i.name }}
                      </div>
                      <!-- 单行本 -->
                      <div v-if="item.par_type == 'theme'" style="color:#0091ff">
                        单行本
                      </div>
                      <!--杂志 -->
                      <div v-if="item.par_type == 'magazine_article'" style="color:#0091ff"
                        @click="magazineDetail(item)">
                        #{{ item.magazine.name }}
                      </div>

                      <div v-if="
                        item.par_type == 'normal_article' ||
                        item.par_type == 'sound_article' ||
                        item.par_type == 'top_article'
                      ">
                        {{ item.visit_times }}
                        <span>阅读</span>
                      </div>
                      <div class="time">
                        {{ item.display_time | timefilters }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 广告 -->
              <div class="bigBox" v-if="
                articleGGIndex.indexOf(index) !== -1 &&
                articleGG != '' &&
                articleGG[index] != undefined &&
                articleGG[index] != null
              ">
                <div class="list-box">
                  <div class="img" @click="
                    articleAdvClick(
                      articleGG[index].param,
                      articleGG[index].url
                    )
                    ">
                    <img :src="articleGG[index].image" />
                    <span class="jd_adv">广告</span>
                  </div>
                  <div class="suggest">
                    <!-- 单行本标题 -->
                    <p @click="
                      articleAdvClick(
                        articleGG[index].param,
                        articleGG[index].url
                      )
                      ">
                      {{ articleGG[index].param.adslot_name }}
                    </p>
                    <div class="message">
                      <div>
                        <span>广告</span>
                      </div>
                      <div class="time"></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div v-if="articleGGIndex.indexOf(index) !== -1 && articleGG!= '' && articleGG[index] != undefined && articleGG[index] != null" class="banner">
                <div class="img">
                  <img :src="articleGG[index].image" alt />
                </div>
                <span>广告</span>
              </div> -->
            </template>
          </div>
          <div class="morePage">
            <div @click="moreData" v-if="more_show">
              <p>加载更多资讯</p>
              <div>
                <img src="@/assets/img/more.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="content-r content-r-fixed">
          <div class="fiexed">
            <div class="right-box">
              <div class="right-centent">
                <div class="right-time">
                  <div @click.stop="day_show = !day_show">
                    <span>{{
                      laberList[laberIndex].publish_date | strToDay
                    }}</span>
                    <img src="@/assets/img/icon1.png" alt />
                  </div>
                  <ul v-if="day_show" class="timeList">
                    <li v-for="(day_list, day_index) in laberList" :key="day_index" @click="changeDay(day_index)">
                      {{ day_list.publish_date | strToDate }}
                    </li>
                  </ul>
                  <div>
                    {{ laberList[laberIndex].month }}.{{
                      laberList[laberIndex].publish_date | strToYear
                    }}
                  </div>
                </div>
                <div class="radio">
                  <img :src="new_audio" style="width: 70px;height: 70px;" alt />
                  <div @click="openPlay" v-if="!showPlay">
                    <img src="@/assets/img/play.png" alt />
                  </div>
                  <div @click="closePlay" v-else>
                    <img src="@/assets/img/icon_open_play.png" alt />
                  </div>
                </div>
                <div class="triangle">
                  <img src="@/assets/img/triangle.png" alt />
                </div>
              </div>
              <ul @click="
                hotDetail(laberList[laberIndex].id, laberList[laberIndex])
                " style="cursor: pointer;">
                <li v-for="(itemSummary, i) in laberList[laberIndex].summary" v-if="itemSummary" :key="i">
                  <p>{{ itemSummary }}</p>
                </li>
              </ul>
            </div>

            <!-- 右侧广告 -->
            <div class="right-box" v-if="right_adv.image">
              <div class="rightTop">
                <img width="100%" :src="right_adv.image" alt=""
                  @click="rightAdvClick(right_adv.param, right_adv.url)" />
                <span>广告</span>
              </div>
            </div>
            <div class="right-box">
              <div class="publish" style="cursor: pointer;" @click="goPublish()">
                <p class="title">本月新刊</p>
                <div class="img">
                  <img :src="publish.cover_url" alt />
                </div>
                <div class="cont">
                  <p>{{ publish.summary }}</p>
                  <p class="time">
                    <span v-if="publish.display_time">{{
                      publish.display_time | timefilters
                    }}</span>
                    <span>NO.{{ publish.maga_all_number }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="right-box">
              <div class="publish" style="cursor: pointer;" @click="goTopAudio()">
                <p class="title">热门音频</p>
                <div class="audio">
                  <img :src="topAudio.img" alt />
                </div>
                <div class="cont">
                  <p>{{ topAudio.content }}</p>
                </div>
              </div>
            </div>
            <div class="right-box">
              <div class="top-article">
                <p class="title">{{ topArticle.title }}</p>
                <ul>
                  <li v-for="(item, i) in topArticle.articleList" :key="i" @click="toHotArticle(item)"
                    style="cursor: pointer">
                    <span>{{ `0` + (i + 1) }}</span>
                    <div>
                      <div class="article-title">{{ item.title }}</div>
                      <p>{{ item.display_time | timefilters }}</p>
                    </div>
                  </li>
                </ul>
                <div v-if="topArticle.articleList.length <= 0" class="rightNoData">
                  暂无数据
                </div>
              </div>
            </div>
            <div class="right-box">
              <div class="top-laber">
                <p class="title">{{ topLaber.title }}</p>
                <ul>
                  <li v-for="(item, i) in topLaber.list" :key="i" @click="tagList(item)">
                    <p>{{ item.name }}</p>
                  </li>
                </ul>
                <div v-if="topLaber.list.length <= 0" class="rightNoData">
                  暂无数据
                </div>
              </div>
            </div>
            <div class="right-box">
              <div style="cursor: pointer;">
                <img src="@/assets/img/laber1.png" alt style="width: 100%;vertical-align: bottom;" @click="goLink" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let vm = null;
import Swiper from "swiper";
import axios from "axios";
import {
  getList,
  getBanner,
  getAdvertise,
  getHotArticle,
  getHotLaber,
  getMagazines,
  getHotAudio,
  getAd
} from "@/api/home";
import { getone, advclick } from "@/api/adv";
import { getNewsWeek } from "@/api/home";
import { getTdkList } from "@/api/tdk";
export default {
  name: "home",
  props: {
    showBtn: [String, Boolean, Number]
  },
  data() {
    return {
      getATId: 0,
      notLogin: false,
      more_show: true,
      adslot_id: [11088, 11097, 11098, 11099],
      day_show: false,
      play_count: 1,
      //昨夜今晨图
      new_audio: require("@/assets/img/radio.png"),
      // 广告图
      ad: require("@/assets/img/top.png"),
      ads: [
        "@/assets/img/top.png",
        "@/assets/img/top.png",
        "@/assets/img/top.png"
      ],
      // 轮播图
      bannerList: [],
      // 文章列表
      list: [],
      otherList: "",
      laberIndex: 0,

      laberList: [
        {
          publish_at: "",
          month: "",
          summary: ["暂无数据"],
          audioserie_cover_url: ""
        }
      ],
      publish: {},
      topAudio: {},
      topArticle: {
        title: "热门文章",
        articleList: []
      },
      topLaber: {
        title: "热门标签",
        list: []
      },
      // 分页
      page: 1,
      per: 8,
      showPlay: false,
      // 判断下推广告
      isXiaTuiGG: false,
      //下推广告收回位
      isXiaTuiGG2: false,

      //判断浮层广告
      isFuCengGG: false,
      isFuCengGG2: false,
      push_down_adv: {
        image: "",
        url: ""
      },

      floating_layer_adv: {
        image: "",
        url: "",
        param: ""
      },
      //顶部广告
      top_adv: {
        // require("@/assets/img/top.png")
        image: null,
        url: "",
        param: ""
      },
      //右侧广告
      right_adv: {
        image: "",
        url: "",
        param: ""
      },
      // banner图广告列表
      bannerGG: [
        // {
        //   cover_url:'',
        //   url:'',
        //   param:'',
        //   bannerable_type:'Adv'
        // }
      ],
      // banner图广告列表
      articleGG: [
        // {
        //   cover_url:'',
        //   url:'',
        //   param:'',
        //   bannerable_type:'Adv'
        // }
      ],
      articleGGIndex: [3, 9, 21]
    };
  },
  watch: {
    showBtn(newValue, oldValue) {
      this.showPlay = newValue;
    }
  },
  methods: {
    async getSwiperAdv() {
      try {
        //轮播广告
        const [res1, res2] = await Promise.all([getone(648), getone(649)]);
        if (res1 != "" && res1.data != "" && res1.data.return_code == 0) {
          if (res1.data.direct_creatives_info[0].adsold) {
            try {
              res1.data.direct_creatives_info.forEach(item => {
                var item2 = {};
                item2.url = item.click_url;
                var img = item.user_define_content;
                img = JSON.parse(img);
                item2.cover_url = img.$img$;
                item2.param = res1.data.direct_creatives_info[0];
                item2.bannerable_type = "Adv";
                this.bannerGG.push(item2);
              });
            } catch (error) { }
          }
        }

        if (res2 != "" && res2.data != "" && res2.data.return_code == 0) {
          if (res2.data.direct_creatives_info[0].adsold) {
            try {
              res2.data.direct_creatives_info.forEach(item => {
                var item2 = {};
                item2.url = item.click_url;
                var img = item.user_define_content;
                img = JSON.parse(img);
                item2.cover_url = img.$img$;
                item2.param = res2.data.direct_creatives_info[0];
                item2.bannerable_type = "Adv";
                this.bannerGG.push(item2);
              });
            } catch (error) { }
          }
        }
      } catch (error) { }

      // 轮播图
      const res = await getBanner({ category: "first" });
      this.bannerList = res.data.data;
      if (this.bannerGG.length == 1) {
        var one = this.bannerGG[0];
        this.bannerList.splice(1, 0, one);
      } else if (this.bannerGG.length == 2) {
        var one = this.bannerGG[0];
        var two = this.bannerGG[1];
        this.bannerList.splice(1, 0, one);
        this.bannerList.splice(3, 0, two);
      } else if (this.bannerGG == []) {
        this.bannerList = res.data.data;
      }
      var _this = this;
      this.$nextTick(function () {
        new Swiper(".swiper-container", {
          observe: true,
          observeParents: true,
          direction: "horizontal",
          loop: true,
          autoplay: true,
          // slidesPerView: "auto",
          slidesPerView: 3,
          centeredSlides: true,
          loopAdditionalSlides: 100,
          // 分页器
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          on: {
            click: function () {
              var item = vm.bannerList[this.realIndex];
              vm.goTo(item);
            }
          }
        });
      });
    },
    toHotArticle(scope) {
      this.$router.push({
        name: "article_detail",
        params: { id: scope.id, isRead: false }
      });
    },
    goTo(scope) {
      if (scope.bannerable_type == "Adv") {
        advclick(scope.param, "home");
        window.open(scope.url, "_blank");
      } else if (scope.bannerable_type == "Magazine") {
        this.$router.push({
          name: "magalog",
          params: {
            id: scope.id,
            title: scope.summary,
            cover: scope.magazine_cover_url,
            time: scope.display_time,
            seria: scope.maga_all_number
          }
        });
      } else if (scope.bannerable_type == "Subject") {
        if (scope.is_jurisdiction) {
          this.$router.push({
            name: "read_free",
            params: {
              id: scope.id,
              type: scope.bannerable_type,
              cover: scope.subject_cover_url,
              title: scope.name,
              time: scope.display_time
            }
          });
        } else {
          this.$router.push({
            name: "read_detail",
            params: { id: scope.id }
          });
        }
      } else if (scope.bannerable_type == "Theme") {
        this.$router.push({
          name: "read_free",
          params: {
            id: scope.id,
            type: scope.bannerable_type,
            cover: scope.theme_cover_url,
            title: scope.name,
            time: scope.display_time
          }
        });
      } else if (scope.bannerable_type == "Article") {
        this.$router.push({
          name: "article_detail",
          params: { id: scope.id, isRead: false }
        });
      }
    },
    hotDetail(id, scope) {
      this.resetSetItem("isActive", 2);
      this.$router.push({
        name: "hot_detail",
        params: {
          id: id,
          PId: scope.audioserie_id,
          pTitle: scope.audioserie_name
        }
      });
    },
    dayShow() {
      this.day_show = !this.day_show;
    },
    changeDay(index) {
      this.laberIndex = index;
      this.day_show = false;
    },
    // 播放
    openPlay() {
      // 播放
      this.showPlay = true;
      this.$emit("getIsPlaying", this.play_count++);
    },
    //暂停播放
    closePlay() {
      this.showPlay = false;
      this.$emit("getClosePlaying", -1);
    },
    // 加载更多
    moreData() {
      this.page += 1;
      this.getInfo();
      this.$emit("getFixed", true);
    },

    // 热门标签
    tagList(scope) {
      this.$router.push({
        name: "hot_laber",
        params: {
          id: scope.id,
          type: "undefined",
          isSearch: false
        }
      });
    },
    getLaber() {
      getHotLaber().then(res => {
        this.topLaber.list = res.data.data;
      });
    },
    // 本月新刊
    getPublish() {
      getMagazines().then(res => {
        this.publish = res.data.data;
      });
    },
    goPublish() {
      this.$router.push({
        name: "magalog",
        params: {
          id: this.publish.id,
          type: this.publish.type,
          title: this.publish.summary,
          cover: this.publish.cover_url,
          time: this.publish.display_time,
          seria: this.publish.maga_all_number
        }
      });
    },
    goTopAudio() {
      this.$router.push({
        name: "radio_detail",
        params: { id: this.topAudio.id }
      });
    },
    // 文章详情
    detail(scope) {
      if (scope.par_type == "sound_article") {
        this.$router.push({
          name: "hot_detail",
          params: { id: scope.id, PId: this.id, pTitle: this.title }
        });
      } else if (scope.par_type == "theme") {
        this.$router.push({
          name: "read_free",
          params: {
            id: scope.id,
            type: scope.article_type,
            is_jurisdiction: scope.is_jurisdiction,
            cover: scope.cover_url,
            title: scope.name,
            time: scope.display_time
          }
        });
      } else {
        this.$router.push({
          name: "article_detail",
          params: { id: scope.id, title: scope.title, isRead: false }
        });
      }
    },
    getInfo() {
      // 列表
      getList({ per: this.per, page: this.page }).then(res => {
        if (res.data.data.length != 0) {
          this.setList(true);
          let data = [];
          for (var i in res.data.data) {
            for (var j in res.data.data[i].data) {
              this.$set(
                res.data.data[i].data[j],
                "par_type",
                res.data.data[i].type
              );
              data.push(res.data.data[i].data[j]);
            }
          }
          if (this.page == 1) {
            this.list = data;
          } else {
            this.$nextTick(() => {
              this.list = this.list.concat(data)
            })
          }
          this.setList(false);
        } else {
          this.more_show = false;
        }
      });
    },
    getBannerGG() { },
    setList(flag) {
      if (flag && this.otherList != "") {
        this.list.push(this.otherList);
        this.otherList = "";
      } else {
        if (this.more_show && this.list.length % 2 == 1) {
          var len = this.list.length - 1;
          this.otherList = this.list[len];
          this.list.splice(len, 1);
        }
      }
    },
    getArticle() {
      getHotArticle().then(res => {
        this.topArticle.articleList = res.data.data;
      });
    },
    freeTheme(scope, id) {
      this.resetSetItem("isActive", 1);
      this.$router.push({
        name: "read_free",
        params: {
          id: id,
          type: scope.article_type,
          is_jurisdiction: scope.is_jurisdiction,
          cover: scope.cover_url,
          title: scope.title,
          time: scope.display_time
        }
      });
    },
    magazineDetail(scope) {
      this.resetSetItem("isActive", 1);
      this.$router.push({
        name: "magalog",
        params: {
          id: scope.magazine.id,
          title: scope.summary,
          cover: scope.cover_url,
          time: scope.display_time,
          seria: scope.maga_all_number
        }
      });
    },
    //跳转订阅
    goMember() {
      this.$router.push({ path: "/member" });
    },
    //监听滚动条事件
    showIcon() {
      // 滚动滚动条时，距离顶部的距离
      // this.minHeight = document.documentElement.scrollTop;
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //变量windowHeight是可视区的高度
      var clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 内容高度
      var height = document.querySelector(".fiexed").scrollHeight;
      // 滚动条下滚
      if (height - scrollTop > clientHeight) {
        $(".fiexed").css({
          position: "initial"
        });
        $(".content-r").css({
          position: "initial"
        });
      } else {
        if (scrollHeight - (scrollTop + clientHeight) <= 130) {
          $(".fiexed").css({
            position: "fixed",
            bottom: "140px",
            right: "10.5%",
            width: "320px"
          });
        } else {
          $(".fiexed").css({
            position: "fixed",
            bottom: "-58px",
            right: "10.5%",
            width: "320px"
          });
        }
      }
    },
    goLink() {
      window.open("https://www.datayicai.com", "_blank");
    },

    // 下推广告关闭
    topCloseGG() {
      this.isXiaTuiGG = false;
      this.isXiaTuiGG2 = true;
    },
    topCloseGG4() {
      this.isXiaTuiGG = true;
      this.isXiaTuiGG2 = false;
    },
    topCloseGG2(data, url) {
      // this.isXiaTuiGG = true;
      // this.isXiaTuiGG2 = false;
      advclick(data, "home");
      window.open(url, "_blank");
    },
    topCloseGG3() {
      this.isXiaTuiGG = false;
      this.isXiaTuiGG2 = false;
    },
    //浮层广告关闭
    fucengGG() {
      this.isFuCengGG = false;
      this.isFuCengGG2 = true;
    },
    fucengGG4() {
      this.isFuCengGG = true;
      this.isFuCengGG2 = false;
    },
    fucengGG2(data, url) {
      advclick(data, "home");
      window.open(url, "_blank");
      // this.isFuCengGG = true;
      // this.isFuCengGG2 = false;
    },
    fucengGG3() {
      this.isFuCengGG = false;
      this.isFuCengGG2 = false;
    },
    //顶部广告跳转
    topAdvClick(data, url) {
      advclick(data, "home");
      window.open(url, "_blank");
    },
    //信息流广告跳转
    articleAdvClick(data, url) {
      advclick(data, "home");
      window.open(url, "_blank");
    },
    //右侧广告跳转
    rightAdvClick(data, url) {
      advclick(data, "home");
      window.open(url, "_blank");
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.showIcon);
    // this.rightHeight = document.querySelector(".fix").clientHeight;
  },
  created() {
    getTdkList({ column: 1 }).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title = res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })

    this.$ba([
      ["ptype", "list"],
      ["acategory", "index"],
      ["acname", "首页"]
    ]);
    this.notLogin = this.$route.params.notLogin;
    vm = this;
    //信息流广告
    getone(685).then(res => {
      if (res != "" && res.data != "" && res.data.return_code == 0) {
        res.data.direct_creatives_info.forEach(item => {
          try {
            var item2 = {};
            item2.url = item.click_url;
            var img = item.user_define_content;
            img = JSON.parse(img.$img$);
            item2.image = img.imgUrl;
            item2.param = res.data.direct_creatives_info[0];
            item2.text = img.$text$;
            if (this.articleGG.length == 0) {
              this.articleGG[3] = item2;
            } else if (this.articleGG.length == 1) {
              this.articleGG[9] = item2;
            } else if (this.articleGG.length == 2) {
              this.articleGG[21] = item2;
            }
          } catch (error) { }
        });
      }
    });
    // 列表
    this.getInfo();

    // // 调用轮播广告图接口
    // axios.get('https://testamsapi.yicai.com/search?id=584&frequency_control_id=7514adde-d693-4bce-b0a4-ef90c09f2dd8&areaId=3100').then(res=>{
    //   console.log(res.data.direct_creatives_info[0].thirdparty_ck_monitor_urls);
    //   this.bannerGG = res.data.direct_creatives_info[0].thirdparty_ck_monitor_urls;
    // })

    this.getSwiperAdv();

    // // 轮播图
    // getBanner({ category: "first" }).then(res => {
    //   this.bannerList = res.data.data;
    //   // console.log(this.bannerGG.length);
    //   // console.log(this.bannerList);
    //   if(this.bannerGG.length == 1){
    //     var one = this.bannerGG[0];
    //     this.bannerList.splice(1,0,"{item.cover_url:"+one+"}")
    //     console.log(this.bannerList)
    //   }else if(this.bannerGG.length == 2){
    //     var one = this.bannerGG[0];
    //     var two = this.bannerGG[1];
    //     this.bannerList.splice(1,0,one);
    //     this.bannerList.splice(3,0,two);
    //     console.log(this.bannerList)
    //   }else if(this.bannerGG == []){
    //     this.bannerList = res.data.data
    //   }
    //   var _this = this;
    //   this.$nextTick(function() {
    //     new Swiper(".swiper-container", {
    //       observe: true,
    //       observeParents: true,
    //       direction: "horizontal",
    //       loop: true,
    //       autoplay: true,
    //       // slidesPerView: "auto",
    //       slidesPerView: 3,
    //       centeredSlides: true,
    //       loopAdditionalSlides: 100,
    //       // 分页器
    //       pagination: {
    //         el: ".swiper-pagination",
    //         clickable: true
    //       },
    //       on: {
    //         click: function() {
    //           var item = vm.bannerList[this.realIndex];
    //           vm.goTo(item);
    //         }
    //       }
    //     });
    //   });
    // });

    // 广告图
    // getAdvertise({
    //   fetchtype: 0,
    //   bidrequest: {
    //     ext: { adslot_id: 11088, ssp_id: 99795589757 },
    //     imp: [{ banner: { pos: 0 } }]
    //   }
    // }).then(res => {
    //   if (res.data.direct_creatives_info != undefined) {
    //     var img = res.data.direct_creatives_info[0].user_define_content;
    //     var arr = JSON.parse(img);
    //     this.ad = arr.imageUrl;
    //   }
    // });
    // 热门文章
    this.getArticle();
    // 热门标签
    this.getLaber();
    // 本月新刊
    this.getPublish();
    // 热门音频
    getHotAudio().then(res => {
      this.topAudio.content = res.data.data.name;
      this.topAudio.id = res.data.data.id;
      this.topAudio.img = res.data.data.cover_url;
    });
    getNewsWeek().then(res => {
      if (res.data.data[0].article.length > 0) {
        try {
          res.data.data[0].article.forEach((item, i) => {
            res.data.data[0].article[i].summary = item.summary.split("\n");
          });
          this.laberList = res.data.data[0].article;
          this.new_audio = this.laberList[this.laberIndex].audioserie_cover_url;
          this.$emit("getATId", res.data.data[0].article[0].audioserie_id);
        } catch (error) { }
      }
    });



    //下推广告
    getone(582).then(res => {
      if (res != "" && res.data != "" && res.data.return_code == 0) {
        try {
          if (res.data.direct_creatives_info[0].adsold) {
            this.push_down_adv.url =
              res.data.direct_creatives_info[0].click_url;
            var img = res.data.direct_creatives_info[0].user_define_content;
            img = JSON.parse(img);
            this.push_down_adv.image = img.imgUrl;
            this.push_down_adv.param = res.data.direct_creatives_info[0];
            this.isXiaTuiGG = true;
          }
        } catch (error) { }
      }
    });
    //浮层广告
    getone(581).then(res => {
      if (res != "" && res.data != "" && res.data.return_code == 0) {
        try {
          if (res.data.direct_creatives_info[0].adsold) {
            this.floating_layer_adv.url =
              res.data.direct_creatives_info[0].click_url;
            var img = res.data.direct_creatives_info[0].user_define_content;
            img = JSON.parse(img);
            this.floating_layer_adv.image = img.imgUrl;
            this.floating_layer_adv.param = res.data.direct_creatives_info[0];
            this.isFuCengGG = true;
          }
        } catch (error) { }
      }
    });

    //顶部广告
    getone(645).then(res => {
      try {
        if (res != "" && res.data != "" && res.data.return_code == 0) {
          if (res.data.direct_creatives_info[0].adsold) {
            this.top_adv.url = res.data.direct_creatives_info[0].click_url;
            var img = res.data.direct_creatives_info[0].user_define_content;
            img = JSON.parse(img);
            this.top_adv.image = img.imgUrl;
            this.top_adv.param = res.data.direct_creatives_info[0];
          }
        }
      } catch (error) { }
    });
    //右侧广告
    getone(650).then(res => {
      if (res != "" && res.data != "" && res.data.return_code == 0) {
        try {
          if (res.data.direct_creatives_info[0].adsold) {
            this.right_adv.url = res.data.direct_creatives_info[0].click_url;
            var img = res.data.direct_creatives_info[0].user_define_content;
            img = JSON.parse(img);
            this.right_adv.image = img.imgUrl;
            this.right_adv.param = res.data.direct_creatives_info[0];
          }
        } catch (error) { }
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/swiper.min.css";

.jd_adv {
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 12px;
  color: #fff;
  background: #33333380;
  line-height: 20px;
  padding: 0 12px;
}

.main {
  // width: 79%;
  width: 1200px;
  margin: 0 auto;
  margin-top: 5px;
}

.topGuangGao {
  position: relative;
  width: 1200px;
  height: 800px;
  // border: 1px solid;
  background: lightcyan;
  margin-bottom: 30px;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}

.topBanner {
  position: relative;
  margin-bottom: 30px;
  display: block;

  span {
    position: absolute;
    left: 2px;
    bottom: 2px;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }

  img {
    width: 100%;
    height: 90px;
    vertical-align: bottom;
  }
}

.main-content {
  display: flex;
  justify-content: space-between;

  .content-l {
    .rotation {
      position: relative;

      .swiper-container {
        width: 100%;
        height: 364px;
        position: relative;
        z-index: 2;
      }

      .swiper-container .swiper-wrapper .swiper-slide {
        width: 33%;

        .laber {
          position: absolute;
          bottom: 40px;
          left: 30px;
          z-index: 3;

          p:first-child {
            background: #fff;
            padding: 2px 10px;
            font-size: 12px;
            display: inline;
          }

          p:last-child {
            font-size: 30px;
            color: #fff;
            margin-top: 4px;
          }
        }

        .others {
          position: absolute;
          bottom: 0;
          z-index: 1;
          width: 100%;
          height: 140px;

          img {
            width: 100%;
            height: 100%;
            opacity: 1;
            object-fit: cover;
          }
        }
      }

      .swiper-container .swiper-wrapper .swiper-slide img {
        width: 100%;
        height: 364px;
        object-fit: cover;
      }

      .swiper-container .swiper-wrapper .swiper-slide-prev {
        width: 12% !important;
        height: 364px !important;
        background: #000;
      }

      .swiper-container .swiper-wrapper .swiper-slide-prev img {
        width: 100%;
        height: 100%;
        opacity: 0.4;
      }

      .swiper-container .swiper-wrapper .swiper-slide-prev div {
        display: none;
      }

      .swiper-container .swiper-wrapper .swiper-slide-next {
        width: 12% !important;
        height: 364px !important;
        background: #000;
      }

      .swiper-container .swiper-wrapper .swiper-slide-next img {
        width: 100%;
        height: 100%;
        opacity: 0.4;
      }

      .swiper-container .swiper-wrapper .swiper-slide-next div {
        display: none;
      }

      .swiper-container .swiper-wrapper .swiper-slide-active {
        width: 76% !important;
      }

      .swiper-pagination {
        bottom: 10px !important;
      }

      >>>.swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        border: 1px solid #fff;
        z-index: 10;
        display: inline-block;
        border-radius: 50%;
        margin: 0 4px;
      }

      >>>.swiper-pagination-bullet-active {
        background: #fff;
      }
    }

    .content-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .bigBox {
        display: inline-block;
        // width: 48%;
        width: 410px;
        cursor: pointer;

        .list-box {
          background: #fff;
          margin-top: 30px;

          .img {
            width: 100%;
            height: 230px;
            position: relative;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              vertical-align: bottom;
            }

            .voiceImg {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: auto;
              height: auto;
            }
          }

          .suggest {
            padding: 22px 30px 20px 30px;

            p {
              font-size: 20px;
              min-height: 60px;
              line-height: 30px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-bottom: 12px;
              text-align: justify;
            }

            .articleType {
              display: flex;
              justify-content: space-between;

              span {
                // flex:1;
                width: 75%;
              }

              .el-button {
                width: 20%;
                height: 28px;
                border-radius: 14px;
                align-items: center;
                justify-content: center;
                padding: 0;
                font-size: 14px;
                color: #0091ff;
                border: 1px solid;
                background: #fff;
              }
            }

            .message {
              display: flex;
              justify-content: space-between;
              font-size: 14px;
              color: #999999;

              // .time {
              //   margin-right: 24px;
              // }
            }
          }
        }
      }

      .banner {
        margin-top: 30px;
        // position: relative;
        width: 100%;

        img {
          vertical-align: bottom;
          width: 100%;
        }

        span {
          font-size: 12px;
          color: #686161;
          position: absolute;
          top: 18px;
          right: 20px;
        }
      }
    }
  }

  .content-r {
    .right-box {
      background: #ffffff;
      margin-bottom: 30px;

      .right-centent {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 30px 20px 30px;
        border-bottom: 1px solid #0091ff;
        position: relative;

        .right-time {
          font-weight: bold;

          div:first-child {
            font-size: 30px;
            position: relative;
            cursor: pointer;

            img {
              position: absolute;
              top: 14px;
              right: 14px;
            }
          }

          ul {
            position: absolute;

            li {
              cursor: pointer;
            }
          }

          .timeList {
            background: #fff;
            position: absolute;
            top: 80%;
            z-index: 3;
            box-shadow: 0px 0px 6px 1px #999999;
            padding: 0;
            left: 24px;

            li {
              list-style: none;
              border-bottom: 1px solid #999;
              padding: 10px 30px;
            }
          }
        }

        .radio {
          position: relative;

          div {
            position: absolute;
            top: 50%;
            right: 50%;
            transform: translate(50%, -50%);
            cursor: pointer;
          }
        }

        .triangle {
          position: absolute;
          bottom: -5px;
          left: 14%;
        }
      }

      ul {
        padding: 20px 27px 20px 46px;

        li {
          list-style-type: square;
          line-height: 30px;

          p {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }

      .publish {
        text-align: center;
        padding: 26px 30px 26px 30px;
        font-size: 16px;

        .title {
          font-weight: bold;
        }

        .img {
          margin: 30px 0 20px 0;
          max-width: 200px;
          height: 253px;
          display: inline-block;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .audio {
          margin: 30px 0 20px 0;
          max-width: 200px;
          height: 200px;
          display: inline-block;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .cont {
          padding: 0 30px;
          line-height: 22px;

          .time {
            font-size: 14px;
            color: #999999;
            text-align: center;

            span:first-child {
              margin-right: 8px;
            }

            // display: flex;
            // justify-content: space-between;
            // align-items: center;
          }
        }
      }

      .top-article {
        text-align: center;
        padding: 26px 30px 10px 30px;
        font-size: 16px;

        .title {
          font-weight: bold;
        }

        ul {
          text-align: left;
          padding: 0;
          margin-top: 20px;

          li {
            list-style-type: none;
            line-height: 24px;
            margin-bottom: 10px;
            display: inline-flex;

            p {
              font-size: 14px;
              color: #999999;
            }

            span {
              font-size: 30px;
              color: #0091ff;
              padding-top: 4px;
              padding-right: 7px;
              font-weight: bold;
            }

            .article-title {
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }

          li:nth-child(2) {
            span {
              opacity: 0.7;
            }
          }

          li:nth-child(3) {
            span {
              opacity: 0.4;
            }
          }
        }
      }

      .top-laber {
        text-align: center;
        padding: 26px 30px 10px 30px;
        overflow: hidden;

        .title {
          font-weight: 600;
          line-height: 24px;
          font-size: 16px;
        }

        ul {
          text-align: left;
          padding: 0;
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          width: 110%;

          li {
            list-style-type: none;
            border: 1px solid #0091ff;
            border-radius: 18px;
            padding: 0px 10px;
            color: #0091ff;
            font-size: 16px;
            margin-right: 20px;
            margin-bottom: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.fix {
  position: absolute;
}

.rFixed {
  position: fixed;
  right: 10.5%;
  width: 21.1%;
  top: 73px;
}

.rightNoData {
  width: 100%;
  background: #fff;
  text-align: center;
  line-height: 200px;
}

// 新增广告

.rightTop {
  position: relative;
  width: 320px;
  height: 250px;
  background: #fff;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}

.topGuangGao_btn {
  position: absolute;
  width: 19px;
  text-align: center;
  padding: 4px 2px;
  top: 0;
  right: -20px;
  display: block;
  overflow: hidden;
  line-height: 14px;
  font-size: 12px;
  border: 1px solid #4a4a4a;
  background: #d8d8d8;
  color: #4a4a4a;
  z-index: 2;
}

.topGuangGao_btn:hover {
  border: 1px solid #4a4a4a;
  background: #4a4a4a;
  color: #fff;
  z-index: 2;
}

.topGuangGao_btn2:hover {
  border: 1px solid #4a4a4a;
  background: #4a4a4a;
  color: #fff;
  z-index: 2;
}

.rightBottomGG {
  // display: none;
  width: 225px;
  height: 150px;
  // border: 1px solid;
  background: #0091ff;
  z-index: 2;
  position: fixed;
  right: 0;
  bottom: 0;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.topGuangGao_btn2 {
  position: absolute;
  top: 0;
  right: 0;
  height: 24px;
  background: #d8d8d8;
  border: 1px solid #4a4a4a;
  color: #4a4a4a;
  line-height: 24px;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  padding: 0 4px;
}

.fucengGG {
  position: relative;
  // border: 1px solid;
  background: #fff;
  z-index: 99;
  width: 1200px;
  height: 500px;
  // margin: auto;
  background: #d8d8d8;
  position: absolute;
  top: 300px;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}

.fucengGGHS {
  width: 365px;
  height: 150px;
  // border: 1px solid;
  background: #fff;
  z-index: 1;
  position: fixed;
  right: 0;
  bottom: 0;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}

.fucengGGHS_btn {
  position: absolute;
  top: 0;
  right: 0;
  height: 24px;
  background: #d8d8d8;
  border: 1px solid #4a4a4a;
  color: #4a4a4a;
  line-height: 24px;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  padding: 0 4px;
}

.fucengGGHS_btn:hover {
  background: #4a4a4a;
  color: #fff;
}

.fucengGGHS_btn2 {
  position: absolute;
  top: 0;
  right: 0;
  height: 24px;
  background: #d8d8d8;
  border: 1px solid #4a4a4a;
  color: #4a4a4a;
  line-height: 24px;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  padding: 0 4px;
}

.fucengGGHS_btn2:hover {
  background: #4a4a4a;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue